/**
 * Transform backend bid data to frontend format
 */
export const transformBidData = (backendBid) => {
  // Map backend status to frontend status
  const statusMap = {
    'DRAFT': 'pending',
    'SENT': 'pending',
    'ACCEPTED': 'accepted',
    'REJECTED': 'rejected',
  };

  const statusTextMap = {
    'DRAFT': 'Draft',
    'SENT': 'Pending Quote',
    'ACCEPTED': 'Accepted',
    'REJECTED': 'Rejected',
  };

  // Build flights array from departure and return dates
  const flights = [
    {
      id: `${backendBid.bid_id}-leg-1`,
      origin: backendBid.departure_airport,
      destination: backendBid.arrival_airport,
      duration: backendBid.estimated_flight_time || 'N/A',
      date: backendBid.departure_date,
    },
  ];

  // Add return flight if exists
  if (backendBid.return_date) {
    flights.push({
      id: `${backendBid.bid_id}-leg-2`,
      origin: backendBid.arrival_airport,
      destination: backendBid.departure_airport,
      duration: backendBid.estimated_flight_time || 'N/A',
      date: backendBid.return_date,
    });
  }

  return {
    id: backendBid.bid_id,
    client: {
      id: backendBid.created_by,
      name: backendBid.client_name,
      email: backendBid.client_email,
      phone: backendBid.client_phone,
      avatarUrl: null,
      isVerified: true,
      company: backendBid.client_name, // Backend doesn't have separate company field
    },
    flights,
    passengers: backendBid.passenger_count,
    status: statusMap[backendBid.status] || 'pending',
    statusText: statusTextMap[backendBid.status] || 'Pending Quote',
    statusCount: 1,
    hasAttachments: false,
    isShortlisted: backendBid.shortlisted || false,
    createdAt: backendBid.created_at,
    updatedAt: backendBid.updated_at,
    notes: backendBid.notes,
    estimatedCost: backendBid.total_amount,
    currency: backendBid.currency || 'USD',
  };
};
